import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import eventival from '../../assets/images/integrations/eventival.webp';
import fiona from '../../assets/images/integrations/fiona.webp';
import mailchimp from '../../assets/images/integrations/mailchimp.webp';
import brevo from '../../assets/images/integrations/brevo.webp';
import getresponse from '../../assets/images/integrations/getresponse.webp';
import wp from '../../assets/images/integrations/wp.webp';

import "./QuickAccess.css"

const QuickAccess = () => {
    const { t } = useTranslation();
    const { isMobile } = useSelector(state => state.ui);
    const { setting } = useSelector(state => state.settings);

    if (!setting)
        return null;

    return (
        <div className="QuickAccess">
            <Nav navbar>
                <UncontrolledDropdown nav inNavbar direction={isMobile ? 'up' : 'down'}>
                    <DropdownToggle nav caret aria-label={t('app.quick_access')}>
                        <i className="fa fa-external-link-square"></i>
                        <span className="QuickAccess__label d-none d-md-inline">&nbsp;{t('app.quick_access')}</span>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {setting.eshop?.uri && (
                            <>
                                <DropdownItem
                                    tag="a"
                                    href={`${setting.eshop.uri}/user/login`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fa fa-tag"></i>&nbsp;Ticketack
                                </DropdownItem>
                                <DropdownItem divider />
                            </>
                        )}
                        {setting.integrations?.eventival && (
                            <DropdownItem
                                tag="a"
                                href="https://bo.eventival.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={eventival} className="img rounded" alt={t('settings.integrations.eventival.title')} />
                                &nbsp; {t('settings.integrations.eventival.title')}
                            </DropdownItem>
                        )}
                        {!!setting.integrations?.fiona?.name && (
                            <DropdownItem
                                tag="a"
                                href={`https://${setting.integrations.fiona.name}.fiona-app.com`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={fiona} className="img rounded" alt={t('settings.integrations.fiona.title')} />
                                &nbsp; {t('settings.integrations.fiona.title')}
                            </DropdownItem>
                        )}
                        {setting.integrations?.wp?.websites?.map((w, index) => (
                            <DropdownItem
                                key={index}
                                tag="a"
                                href={w.uri}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={wp} className="img rounded" alt={`${t('settings.integrations.wp.title')} — ${w.name}`} />
                                &nbsp; {w.name}
                            </DropdownItem>
                        ))}
                        {setting.integrations?.mailchimp && (
                            <DropdownItem
                                tag="a"
                                href="https://mailchimp.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={mailchimp} className="img rounded" alt={t('settings.integrations.mailchimp.title')} />
                                &nbsp; {t('settings.integrations.mailchimp.title')}
                            </DropdownItem>
                        )}
                        {setting.integrations?.brevo && (
                            <DropdownItem
                                tag="a"
                                href="https://www.brevo.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={brevo} className="img rounded" alt={t('settings.integrations.brevo.title')} />
                                &nbsp; {t('settings.integrations.brevo.title')}
                            </DropdownItem>
                        )}
                        {setting.integrations?.getresponse && (
                            <DropdownItem
                                tag="a"
                                href="https://www.getresponse.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark"
                            >
                                <img src={getresponse} className="img rounded" alt={t('settings.integrations.getresponse.title')} />
                                &nbsp; {t('settings.integrations.getresponse.title')}
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Nav>
        </div>
    );
}

export default QuickAccess;
